<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="flowConsultForm" :model="formData" class="full-width-input" :disable="readOnly"
       style="width: 100%;"
      label-width="120px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12" v-if="formData.SpecialistConsult.createUserName">
          <el-form-item label="创建人" >
            <span class="input-item input-label" >{{formData.SpecialistConsult.createUserName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="咨询内容" prop="SpecialistConsult.consultContent">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.SpecialistConsult.consultContent"
              :clearable="true" placeholder="咨询内容"
            />
            <span class="input-item input-label" v-else>{{formData.SpecialistConsult.consultContent}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="咨询内容附图" prop="SpecialistConsult.consultImages">
            <el-upload v-if="!readOnly"
              class="upload-image-item upload-image-multi" name="uploadFile" :headers="getUploadHeaders"
              :action="getUploadActionUrl('/admin/app/specialistConsult/upload')"
              :data="{fieldName: 'consultImages', asImage: true}"
              :on-success="onConsultImagesUploadSuccess"
              :on-remove="onConsultImagesRemoveFile"
              :before-upload="pictureFile"
              :on-error="onUploadError" :on-exceed="onUploadLimit"
              list-type="picture-card" :file-list="flowConsultForm.consultImages.impl.fileList" :limit="flowConsultForm.consultImages.impl.maxCount"
              :show-file-list="true">
              <i class="el-icon-plus upload-image-item"></i>
            </el-upload>
            <template v-else>
              <img v-for="item in flowConsultForm.consultImages.impl.fileList" :key="item.url"
                class="table-cell-image" :src="item.url" />
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="对接专家名" prop="SpecialistConsult.specialistName">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.SpecialistConsult.specialistName"
              :clearable="true" placeholder="对接专家名"
            />
            <span class="input-item input-label" v-else>{{formData.SpecialistConsult.specialistName}}</span>
          </el-form-item>
        </el-col>
        <div v-if="formData.SpecialistConsult.auditStatus==='1'">
          <el-col :span="12">
            <el-form-item label="回复内容" prop="SpecialistConsult.specialistReply">
              <span class="input-item input-label" >{{formData.SpecialistConsult.specialistReply}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="回复时间" prop="SpecialistConsult.replyTime">
              <span class="input-item input-label" >{{formData.SpecialistConsult.replyTime}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="回复图片" prop="SpecialistConsult.consultImages">
              <img v-for="item in flowConsultForm.consultImages.impl.fileList" :key="item.url"
                   class="table-cell-image" :src="item.url" />
            </el-form-item>
          </el-col>
        </div>

      </el-row>
    </el-form>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />

  </div>
</template>

<script>
import { mapActions } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
import flowMixins from '../../mixins/flowMixins.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { DictionaryController, SpecialistConsultController } from '@/api';
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'flowConsult';

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  name: 'flowConsultForm',
  props: {
    // 是否运行时任务
    isRuntimeTask: {
      type: [Boolean, String]
    },
    // 是否草稿
    isDraft: {
      type: [Boolean, String],
      default: false
    },
    // 是否只读
    readOnly: {
      type: Boolean,
      default: false
    },
    // 流程实例id
    processInstanceId: {
      type: String
    },
    // 抄送消息id
    messageId: {
      type: String
    },
    // 当前任务实例id
    taskId: {
      type: String
    },
    // 任务变量列表
    taskVariableList: {
      type: Array
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, flowMixins],
  data () {
    return {
      imgViewerVisible: false,
      imgList: [],
      formData: {
        SpecialistConsult: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          createUserName: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          subjectName: undefined,
          consultContent: undefined,
          consultImages: undefined,
          specialistId: undefined,
          specialistName: undefined,
          specialistReply: undefined,
          replyTime: undefined,
          replyImages: undefined,
          upvoteCount: undefined,
          auditStatus: undefined,
          commentCount: undefined,
          consultScore: undefined,
          consultEvaluate: undefined,
          evaluateTime: undefined,
          isDatasourceInit: false,
          auditBy: undefined
        }
      },
      // 保存草稿后返回的taskId
      draftTaskId: undefined,
      // 保存草稿后返回的流程实例ID
      draftProcessInstanceId: undefined,
      flowConsultForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        consultImages: {
          impl: new UploadWidget(5)
        },
        isInit: false
      },
      userInfo: {}
    }
  },
  methods: {
    // 启动流程
    handlerStart (operation, copyItemList, xml) {
      // 启动并保存草稿后再次提交
      if (this.draftProcessInstanceId != null && this.draftTaskId != null) {
        return this.handlerOperation(operation, copyItemList);
      }
      return new Promise((resolve, reject) => {
        this.$refs.flowConsultForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, true, xml).then(res => {
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            return SpecialistConsultController.startAndTakeUserTaskFlowConsult(this, {
              processDefinitionKey: processDefinitionKey,
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              flowTaskCommentDto: {
                approvalType: operation.type
              },
              specialistConsultDto: {
                ...formData.masterData
              },
              ...formData.relationData,
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            });
          }).then(res => {
            this.$message.success('启动成功！');
            resolve();
          }).catch(e => {
            reject(e);
          });
        });
      });
    },
    // 流程操作
    handlerOperation (operation, copyItemList, xml) {
      return new Promise((resolve, reject) => {
        this.$refs.flowConsultForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, this.isDraft, xml).then(res => {
            // 加签、减签操作
            if (operation.type === this.SysFlowTaskOperationType.CO_SIGN || operation.type === this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              return this.submitConsign((res || {}).assignee, operation.type === this.SysFlowTaskOperationType.CO_SIGN);
            }
            // 自由跳
            if (operation.type === this.SysFlowTaskOperationType.FREE_JUMP) {
              return FlowOperationController.freeJump(this, {
                processInstanceId: this.processInstanceId,
                sourceTaskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                delegateAssignee: (res || {}).assignee,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回操作
            if (operation.type === this.SysFlowTaskOperationType.REJECT || operation.type === this.SysFlowTaskOperationType.REJECT_TO_TASK) {
              return FlowOperationController.rejectRuntimeTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回到起点
            if (operation.type === this.SysFlowTaskOperationType.REJECT_TO_START) {
              return FlowOperationController.rejectToStartUserTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 撤销操作
            if (operation.type === this.SysFlowTaskOperationType.REVOKE) {
              this.$confirm('是否撤销此任务？').then(res => {
                return FlowOperationController.rejectHistoricTask(this, {
                  processInstanceId: this.processInstanceId,
                  taskId: this.taskId,
                  taskComment: '任务处理人撤销任务',
                  taskVariableData: {
                    latestApprovalStatus: operation.latestApprovalStatus
                  }
                });
              }).catch(e => {
                return Promise.reject(e);
              });
            }
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            let params = {
              taskId: this.taskId || this.draftTaskId,
              processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
              flowTaskCommentDto: {
                taskComment: (res || {}).message,
                approvalType: operation.type,
                delegateAssignee: operation.type === this.SysFlowTaskOperationType.TRANSFER ? (res || {}).assignee : undefined
              },
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            }
            // 非只读状态下，提交修改数据
            if (!this.readOnly) {
              // 主表数据
              params.specialistConsultDto = {
                ...formData.masterData
              };
              // 关联数据
              params = {
                ...params,
                ...formData.relationData
              };
            }

            return SpecialistConsultController.submitUserTaskFlowConsult(this, params);
          }).then(res => {
            this.reloadMessage(this);
            if (operation.type !== this.SysFlowTaskOperationType.CO_SIGN && operation.type !== this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              this.$message.success(operation.label + '成功！');
            }
            resolve();
          }).catch(e => {
            console.log(e);
          });
        });
      });
    },
    // 保存草稿
    handlerDraft () {
      return new Promise((resolve, reject) => {
        let formData = this.getFormDataImpl();
        let params = {
          processDefinitionKey: processDefinitionKey,
          processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
          specialistConsultDto: {
            ...formData.masterData
          },
          ...formData.relationData
        }
        SpecialistConsultController.startAndSaveDraftFlowConsult(this, params).then(res => {
          this.$message.success('草稿保存成功！');
          this.draftProcessInstanceId = res.data.processInstanceId;
          this.draftTaskId = res.data.taskId;
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    },
    // 获取表单数据
    getFormDataImpl () {
      // 一对一、一对多、多对多关联数据
      let relationData = {};

      return {
        masterData: {
          ...this.formData.SpecialistConsult
        },
        relationData: relationData
      }
    },
    // 获取流程表单数据
    getMasterData (operationType, assignee) {
      let taskVariableData;
      if (Array.isArray(this.taskVariableList) && this.taskVariableList.length > 0) {
        taskVariableData = this.taskVariableList.reduce((retObj, item) => {
          retObj[item.variableName] = this.formData.SpecialistConsult[item.variableName] || '';
          return retObj;
        }, {});
      }
      // 会签操作设置多实例处理人集合
      assignee = (assignee && assignee !== '') ? assignee.split(',') : undefined;
      if (operationType === this.SysFlowTaskOperationType.MULTI_SIGN) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.assigneeList = assignee;
      } else if (operationType === this.SysFlowTaskOperationType.SET_ASSIGNEE) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.appointedAssignee = Array.isArray(assignee) ? assignee.join(',') : undefined;
      }
      return {
        ...this.getFormDataImpl(),
        taskVariableData
      }
    },
    // 初始化流程表单
    initFormData () {
      if (!this.isStartFlow) {
        // 流程办理
        let params = {
          processInstanceId: this.processInstanceId,
          taskId: this.taskId
        }
        let httpCall = null;
        if (this.isDraft || this.isDraft === 'true') {
          // 草稿数据
          httpCall = FlowOperationController.viewDraftData(this, {
            processDefinitionKey: processDefinitionKey,
            processInstanceId: this.processInstanceId
          });
        } else if (this.messageId != null) {
          // 抄送消息
          httpCall = FlowOperationController.viewCopyBusinessData(this, {
            messageId: this.messageId
          });
        } else {
          httpCall = (this.taskId && this.isRuntime) ? SpecialistConsultController.viewTaskBusinessDataFlowConsult(this, params) : SpecialistConsultController.viewHistoricTaskBusinessDataFlowConsult(this, params)
        }
        httpCall.then(res => {
          this.formData.SpecialistConsult = { ...res.data };
          let consultImagesDownloadParams = {
            id: this.formData.SpecialistConsult.id,
            fieldName: 'consultImages',
            asImage: true
          }
          this.formData.SpecialistConsult.auditBy = this.userInfo.userType
          this.flowConsultForm.consultImages.impl.fileList = this.parseUploadData(this.formData.SpecialistConsult.consultImages, consultImagesDownloadParams);
          // 获取一对多、多对多数据
          this.refreshFlowConsultForm(true);
        }).catch(e => {});
      } else {
        // 启动流程
      }
    },
    onCancel (isSuccess) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess);
      }
    },
    /**
     * 更新问答表单
     */
    refreshFlowConsultForm (reloadData = false) {
      if (!this.flowConsultForm.isInit) {
        // 初始化下拉数据
      }
      this.flowConsultForm.isInit = true;
    },
    /**
     * 咨询内容附图上传成功
     */
    onConsultImagesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.flowConsultForm.consultImages.impl.onFileChange(file, fileList);
        this.formData.SpecialistConsult.consultImages = this.fileListToJson(this.flowConsultForm.consultImages.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除咨询内容附图
     */
    onConsultImagesRemoveFile (file, fileList) {
      this.flowConsultForm.consultImages.impl.onFileChange(file, fileList);
      this.formData.SpecialistConsult.consultImages = this.fileListToJson(this.flowConsultForm.consultImages.impl.fileList);
    },
    deleteAttachedFiles (file, fileList, index) {
      fileList.splice(index, 1)
      this.onAttachedFilesRemoveFile(file, fileList)
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    formInit () {
      this.initFormData();
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    ...mapActions(['reloadMessage'])
  },
  computed: {
    isStartFlow () {
      return this.processInstanceId == null;
    },
    isRuntime () {
      return typeof this.isRuntimeTask === 'string' ? this.isRuntimeTask === 'true' : this.isRuntimeTask;
    }
  },
  mounted () {
    this.userInfo = this.$store.state.userInfo
    // 初始化页面数据
    this.formInit();
  }
}
</script>
